export default __webpack_public_path__ + "static/media/26.abd812c5.webp";